"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connect = Connect;
exports.RequestBalance = RequestBalance;
exports.SendCommand = SendCommand;
var _types = require("./types");
function Connect() {
  return {
    type: _types.CONNECT
  };
}
function RequestBalance() {
  return {
    type: _types.REQUEST_BALANCE
  };
}

/**
 * primarly allow the game to send custom commands.
 */
function SendCommand(command) {
  return {
    type: _types.COMMAND_SEND,
    payload: command
  };
}
//# sourceMappingURL=actions.js.map